import React, { useState, useEffect, useRef } from "react";
import "../../App.css";



// Hero Section Component
function HeroSection() {
  const [showTitle, setShowTitle] = useState(false);
  const [showDescription, setShowDescription] = useState(false);
  const [showStats, setShowStats] = useState(false);

  useEffect(() => {
    const timer1 = setTimeout(() => setShowTitle(true), 1500);
    const timer2 = setTimeout(() => setShowDescription(true), 2500);
    const timer3 = setTimeout(() => setShowStats(true), 3500);
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
    };
  }, []);

  const handleScrollDown = () => {
    window.scrollBy({
      top: 800,
      behavior: 'smooth'
    });
  };

  return (
    <section className="hero-section">
      <div className="hero-section__video-container">
        <video
          className="hero-section__video"
          src="/GeotechVideoforWeb.mp4"
          autoPlay
          muted
          loop
          playsInline
        />
      </div>

      {/* Scroll Down Arrow */}
      <div className="scroll-down-arrow" onClick={handleScrollDown}>
        <div className="scroll-arrow-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 10L12 15L17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;